export default {
    followUs: 'Siga-nos nas redes',
    buy: 'Comprar em dinheiro',
    personalPurchaseLink:'centros-de-atencion',
}